import { getObject } from "./api";
import apiClient from "./apiClient";

const API_URL = "/api/users/"; // Ajusta la URL según sea necesario

export const getMe = async () => {
  const url = `${API_URL}me/`;
  const response = await getObject(url);
  return response.data;
};

export const getUsers = async (formId = null) => {
  try {
    const params = {};
    if (formId) {
      params.form_id = formId;
    }

    const response = await apiClient.get(API_URL, { params });
    return response.data.results || response.data || [];
  } catch (error) {
    console.error('Error al obtener usuarios:', error);
    throw error;
  }
};


// export const logout = async () => {
// window.location.href = "/cvsa_users/logout/";

  // const url = `admin/logout/`;
  // axios.defaults.xsrfCookieName = 'csrftoken';
  // axios.defaults.xsrfHeaderName = 'X-CSRFToken';
  // axios.defaults.withCredentials = true;
  // // const csrfmiddlewaretoken = getCSRFToken();
  // const response = await axios.post(`${apiBase}${url}`, {
  //   // headers: { "X-CSRFToken": csrfmiddlewaretoken },
  //   // data: {
  //   //   csrfmiddlewaretoken: csrfmiddlewaretoken,
  //   // },
  //   withCredentials: true,
  // });
  // return response.data;
// }
